import * as React from 'react';

import { ExecutionDetailsSection, IExecutionDetailsSectionProps } from './ExecutionDetailsSection';
import { ExecutionStepDetails } from './ExecutionStepDetails';

export function ExecutionDetailsTasks(props: IExecutionDetailsSectionProps) {
  return (
    <ExecutionDetailsSection name={props.name} current={props.current}>
      <ExecutionStepDetails item={props.stage} />
    </ExecutionDetailsSection>
  );
}

export namespace ExecutionDetailsTasks {
  export const title = 'taskStatus';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/stages/core/ExecutionDetailsTasks.tsx